import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { smartDocParamType_External } from '@app/advisor-content-shared';
import { FadeScrollWrapper } from '@app/styles';
import { Editor_SmartDocParam } from '../Editor_SmartDocParam/Editor_SmartDocParam.js';
import { BadImplementationException } from '@nu-art/ts-common';
import './Editor_SmartDocParams.scss';
export class Editor_SmartDocParams extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    createNewExternalParamType = async (dynamicParamKey, externalParamKey) => {
        if (!this.props.allowedParamTypes.includes(smartDocParamType_External))
            throw new BadImplementationException('Trying to add an external param to a doc that does not allow external params!');
        const externalSubType = this.props.allowedParamSubTypes[smartDocParamType_External]?.[0];
        if (!externalSubType)
            throw new BadImplementationException('Trying to add an external param to a doc but did not provide at least one allowed external param sub type');
        const params = this.state.editable;
        const newParam = {
            key: externalParamKey,
            type: smartDocParamType_External,
            subType: externalSubType,
        };
        //Update the dynamic param that requested the creation
        const dynamicParamIndex = params.item.findIndex(param => param?.key === dynamicParamKey);
        if (dynamicParamIndex === -1)
            throw new BadImplementationException('Called createNewExternalParamType with a dynamic param key for a non existing param');
        params.item[dynamicParamIndex].externalKey = newParam.key;
        //Insert the external param
        params.updateArrayAt(newParam);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'editor__smart-doc-params', children: [this.renderLegend(), _jsx(FadeScrollWrapper, { children: this.renderParams() })] });
    }
    renderLegend = () => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-params__legend', children: [_jsxs(LL_H_C, { className: 'editor__smart-doc-params__legend-item', children: [_jsx("div", { className: 'legend-color-icon static' }), "Static"] }), _jsxs(LL_H_C, { className: 'editor__smart-doc-params__legend-item', children: [_jsx("div", { className: 'legend-color-icon dynamic' }), "Dynamic"] }), _jsxs(LL_H_C, { className: 'editor__smart-doc-params__legend-item', children: [_jsx("div", { className: 'legend-color-icon external' }), "External"] }), _jsxs(LL_H_C, { className: 'editor__smart-doc-params__legend-item', children: [_jsx("div", { className: 'legend-color-icon ehr' }), "EHR"] })] });
    };
    renderParams = () => {
        const params = this.state.editable;
        return _jsx(LL_H_C, { className: 'editor__smart-doc-params__params-wrapper', children: params.item.map((param, index) => {
                const editable = params.editProp(index, {});
                editable.setOnDelete(() => params.removeArrayItem(index));
                return _jsx(Editor_SmartDocParam, { editable: editable, editMode: this.state.editMode, params: params.item, createNewExternalParam: this.createNewExternalParamType, allowedParamTypes: this.props.allowedParamTypes, allowedParamSubTypes: this.props.allowedParamSubTypes }, param?.key);
            }) });
    };
}
//# sourceMappingURL=Editor_SmartDocParams.js.map